module.exports = __webpack_public_path__ + "static/media/iconShopping.4dc0f8ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/iconShopping.svg
// module id = 140
// module chunks = 1